import styles from './Dashboard.module.scss'
import productList from '../utils/products'
import { useNavigate, useLocation } from 'react-router-dom'
import { getLangName as t } from '../utils/index'

function Dashboard() {
  const navigate = useNavigate();
  const handleDetail = (item) => {
    navigate('/dashDetail/' + item.key);
  }
  return <>
    <div className={styles.Dashboard}>
      <div className={styles.Dashboard_title}>{t('ProductCenter')}</div>
      <div className={styles.Dashboard_box}>
        {productList.map(item => <div className={styles.Dashboard_box_item} onClick={() => handleDetail(item)}>
          <img src={item.img} />
          <div>
            {item.title}
            <div>{t('ViewDetails')}</div>
          </div>
        </div>)}
      </div>
    </div>
  </>;
}

export default Dashboard;